'use strict';

// ----------------------------------------
// Imports
// ----------------------------------------

import 'jquery.mmenu';

// ----------------------------------------
// Private
// ----------------------------------------
let $icon = $('#mob-open');
let $filterBtn = $('.filter-mob');
let $filtersMenu = $('#mob-filters');

// ----------------------------------------
// Public
// ----------------------------------------

function mobileMenu () {
	let $menu = $('#mob-menu').mmenu({
		'extensions': [
			'pagedim-black',
			'theme-white',
			'fx-menu-slide'
		]
	});

	let API = $menu.data('mmenu');

	$icon.on('click', function () {
		API.open();
	});

	API.bind('open:finish', function () {
		setTimeout(function () {
			$icon.addClass('is-active');
		}, 100);
	});
	API.bind('close:finish', function () {
		setTimeout(function () {
			$icon.removeClass('is-active');
		}, 100);
	});

	$('.header__menu').each(function () {
		if ($('.header__sub-menu-link').hasClass('active')) {
			let id = $('.header__sub-menu-link.active').attr('data-id');
			$('.header__menu-link[data-id="' + id + '"]').addClass('active');
		}
	});
}

function filterMenu () {
	let $menu = $filtersMenu.mmenu({
		navbar: {
			title: 'Filtr'
		},
		// "navbars": [
		// 	{
		// 		"position": "top",
        //
		// 		"content": [
		// 			"title",
		// 			"close"
		// 		]
		// 	}
		// ],
		'extensions': [
			'pagedim-black',
			'theme-white',
			'fx-menu-slide',
			'border-none'
		]
	});

	let API = $menu.data('mmenu');

	$filterBtn.on('click', function () {
		API.open();
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {mobileMenu, filterMenu};



// WEBPACK FOOTER //
// ./src/js/_modules/mobile-menu.js